<div
  class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 h-58"
>
  <div class="flex gap-2 items-center">
    <div class="flex-1 flex items-center">
      <ui-skeleton class="inline-block h-4 w-[80%] max-w-45 rounded-full" />
    </div>
    <ui-skeleton class="inline-block flex-none size-8 rounded-md" />
  </div>
  <ng-content />
</div>
